import React from 'react'
import styles from './styles.module.scss'

function WorkplaceLabel({ id, name, color, initial, className }) {
  return (
    <div className={`${styles.wpContainer} ${className}`}>
      <div className={`${styles.initial} ${styles[color]}`}>{initial}</div>
      <span className={styles.name}>{`${name.slice(0, 20)}${name.length > 20 ? '...' : ''}`}</span>
    </div>
  )
}

export default WorkplaceLabel
